import { apiService } from "../services/base-api-service";
import { endPoints, getDocEditorServiceEndPoint } from "../services/api-constants";
import { getAuthHeader, readCookie } from "../utils/helpers";

class DocEditorService {
  DocEditorService(url) {
    return getDocEditorServiceEndPoint(url);
  }

  GetEditorQueryInfo(id) {
    const apiEndpoint = this.DocEditorService(`${endPoints.docEditorService.EDITOR_INFO.replace(":id", id)}`);

    return apiService.get(apiEndpoint, null, getAuthHeader());
  }

  ProcessAnnotationsBlob(data) {
    const apiEndpoint = this.DocEditorService(`${endPoints.docEditorService.PROCESS_ANNOTATION}`);

    return apiService.put(apiEndpoint, data, getAuthHeader());
  }
  ReplaceSignature(data) {
    const apiEndpoint = this.DocEditorService(`${endPoints.docEditorService.REPLACE_SIGNATURE}`);

    return apiService.post(apiEndpoint, data, getAuthHeader());
  }

  AddWizard(data) {
    const apiEndpoint = this.DocEditorService(`${endPoints.docEditorService.ADD_WIZARD}`);

    return apiService.post(apiEndpoint, data, getAuthHeader());
  }

  TrackEvent(data) {
    const apiEndpoint = this.DocEditorService(`${endPoints.docEditorService.TRACK_EVENT}`);

    return apiService.post(apiEndpoint, data, getAuthHeader());
  }
  SaveEditorQueryInfo(data) {
    const apiEndpoint = this.DocEditorService(`${endPoints.docEditorService.SAVE_EDITOR_INFO}`);

    return apiService.post(apiEndpoint, data, getAuthHeader());
  }
}

export default new DocEditorService();
